import { mapActions, mapState } from 'vuex'

import { TIPO_GRUPO } from '../../util/constantes';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      loadingGrupos: false,

      validacao: {
        grupoPai: [{ required: true }],
        nome: [{ required: true }]
      },

      filtroTipoGrupo: 'TODOS',

      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    }
  },

  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "GRUPOS_CONTA"
          })[0];
      },
    }),
    ...mapState('subGrupoPlanoContasStore', {
      subGrupoContaPesquisa(state){ return state.subGrupoPlanoContaPesquisa },
      listaSubGrupoConta(state) { return state.listaSubGrupoConta },
      subGrupoConta(state) { return state.subGrupoPlanoContaSelecionado },
      labelQuantidade(state) { return state.labelQuantidade },
      gruposDisponiveis(state) { return state.gruposDisponiveis }
    }),

    tiposGrupo() {
      return TIPO_GRUPO;
    },

    exibirBotaoNovoSubgrupoConta() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarSubgrupoConta() {
      return (
        (this.subGrupoConta.id === 0 && this.permissoes.cadastro)
        || (this.subGrupoConta.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverSubgrupoConta() {
      return this.subGrupoConta.id !== 0 & this.permissoes.remocao;
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('subGrupoPlanoContasStore',[
      'listarSubGrupoConta',
      'listarGrupos',
      'gravarSubGrupoConta',
      'limparSubGrupoContaListadas',
      'recuperarSubGrupoConta',
      'novoSubGrupoConta',
      'limparSubGrupoContaPesquisa',
      'removerSubGrupoConta',
    ]),

    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    novoHandler() {
      this.novoSubGrupoConta();
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },

    limparHandler() {
      this.limparSubGrupoContaPesquisa();
    },

    pesquisarHandler() {
      this.subGrupoContaPesquisa.pagina = 0;
      this.limparSubGrupoContaListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.subGrupoContaPesquisa.pagina === 0) { this.showLoading(); }

      if(this.subGrupoContaPesquisa.grupoPai) {
        delete this.subGrupoContaPesquisa.grupoPai.grupoPai
      }
      this.listarSubGrupoConta(this.subGrupoContaPesquisa).then((resultado) => {
        if(this.subGrupoContaPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.subGrupoContaPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.subGrupoContaPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.subGrupoContaPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      })
    },

    gravarHandler() {
      this.$refs['form'].validate(elFormValidate => {
        const formIsInvalid = !elFormValidate;
        if(formIsInvalid) {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          return
        }
          this.gravar();
      });
    },

    gravar() {
      const payload = {
        ...this.subGrupoConta,
      }

      delete this.subGrupoConta.grupoPai.grupoPai

      this.showLoading();
      this.gravarSubGrupoConta(payload)
      .then(resultado => {
        if(resultado.status == 'SUCESSO') {
          this.$message.success('Subgrupo de contas gravado com sucesso.')
          this.listarSubGrupoConta({});
        } else {
          this.$message.warning('Falha ao gravar novo subgrupo.')
        }
      }).catch(() => {
        this.$message.error('Não foi possível conectar ao servidor.')
        
      }).finally(() => {
        this.hideLoading();
      })
    },

    recuperarHandler(subgrupo) {
      this.recuperar(subgrupo);
    },

    recuperar(subgrupo) {

      this.showLoading();
      this.recuperarSubGrupoConta({ id: subgrupo.id })
      .then(() => {
        this.hideLoading();
      }).catch(() =>{
        this.hideLoading();
        this.$message.error('Não foi possível conectar ao servidor.')
      })
    },

    removerHandler() {
      this.$confirm('Deseja realmente remover esse subgrupo?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      })
    },

    remover() {
      const payload = { id: this.subGrupoConta.id }

      this.showLoading();
      this.removerSubGrupoConta(payload)
      .then((resultado) => {
        if(resultado.status == 'SUCESSO') {
          this.$message.success(resultado.mensagem);
          this.listarSubGrupoConta({})
        } else if(resultado.status == 'ERRO'){
          this.$message.warning(resultado.mensagem)
        }
      }).catch(() => {
        this.$message.error('Erro ao conectar com o servidor.')
      }).finally(() => {
        this.hideLoading();
      })
    },

    filtrarGruposSelect(queryString) {
      let tipoSelecionado = undefined
      if(this.filtroTipoGrupo != 'TODOS') {
        tipoSelecionado = this.filtroTipoGrupo
      }

      let payload = { nome: queryString, tipo: tipoSelecionado }
      this.loadingGrupos = true;
      this.listarGrupos(payload)
      .then(() => {
      this.loadingGrupos = false;  
      });
    },
  },
}